<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 5291.66 5291.66"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">

 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g id="_2193897281600">
   <path d="M94.86 4495.27c0,324.05 -71.62,701.53 255.1,701.53l4591.74 0c326.72,0 255.1,-377.48 255.1,-701.53 0,-830.96 -1697.63,-1211.69 -2742.29,-1211.69 -822.86,0 -2359.65,490.01 -2359.65,1211.69z"/>
   <path d="M1370.35 1179.02c0,440.26 -23.91,741.51 395.09,1135.48 476.5,447.99 1284.28,447.99 1760.78,0 776.06,-729.67 418.75,-2219.64 -944.17,-2219.64 -683.12,0 -1211.7,648 -1211.7,1084.16z"/>
  </g>
 </g>
</svg>
